import { z } from 'zod'

const decoderOutputSchema = z.number().int().nonnegative().safe()
const snapshotSchema = z.object({
  id: z.number().int().positive().safe(),
  description: z.string(),
  address: decoderOutputSchema,
  index: decoderOutputSchema,
  stateName: z.string().min(1),
  isRunning: z.boolean().optional(),
  etZone: z.object({
    id: z.union([z.number().int().positive().safe(), z.string().min(1)]),
    name: z.string().min(1),
  }).nullable(),
})

export const stationDeletionSnapshotSchema = snapshotSchema.extend({
  description: z.string().nullish(),
  address: decoderOutputSchema.optional(),
  index: decoderOutputSchema.optional(),
  controller: z.object({
    name: z.string().nullish(),
    address: decoderOutputSchema,
    index: decoderOutputSchema,
  }).nullish(),
}).transform(({ controller, ...station }) => ({
  ...station,
  description: station.description || controller?.name || String(station.id),
  address: controller?.address ?? station.address,
  index: controller?.index ?? station.index,
})).pipe(snapshotSchema)

export type StationDeletionSnapshot = z.output<typeof stationDeletionSnapshotSchema>

export type StationDeletionSource = Pick<StationDeletionSnapshot, 'id' | 'stateName' | 'isRunning'>
